import { FilterValue, SavedFilters, savedFiltersKey } from "./types";

type Props = {
    pageKey: string;
    viewId: string;
}

type Response = {
    [key: string]: FilterValue;
}

export const getFilters = ({ pageKey, viewId }: Props): Response => {
    const savedFilters = localStorage.getItem(savedFiltersKey) || '{}';
    const parsedFilters: SavedFilters = JSON.parse(savedFilters);
    const pageInfo = parsedFilters[pageKey] || {};
    const filterView = pageInfo.filterViews?.[viewId];

    if (!filterView) return {};

    // @TODO adjust this yet
    const filters = Object.entries(filterView.filters).reduce((acc, [key, value]) => {
        if (value.type === 'dateRange') {
            acc[key] = (value.value as [string, string]).map(date => new Date(date))
        } else {
            acc[key] = value.value
        }

        return acc
    }, {} as Response)

    return filters;
}